<template>
  <v-container fluid>
    <v-row class="mt-2">
      <v-col cols="12" md="6" offset-md="3">
        <v-card outlined class="text-center pa-4">
          <v-avatar :size="240" color="transparent" class="ma-1">
            <v-img :src="logoUrl" :lazy-src="''">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
          <h1 class="ml-4">Mailadresse ändern</h1>
          <v-card-text>
            Lieber Bundesbruder, <br>
            <br>
            deine E-Mailadresse {{ mail }} ist leider nicht im System vorhanden.<br>
            Damit du auf Korpodesk zugreifen kannst musst du entweder beim Schriftführer die E-Mailadresse {{ mail }} hinterlegen
            lassen oder du kannst auf dieser Seite eine andere E-Mailadresse verwenden. Du musst immer die Adresse angeben, auf der du
            auch unsere E-Mails empfängst.<br><br>
            <v-text-field
              outlined
              label="Neue E-Mailadresse eintragen"
              v-model="neueEmail"
              type="passwemailord"></v-text-field>
            <v-btn class="primary" @click="updateEmail()">E-Mailadresse ändern</v-btn>
          </v-card-text>
          {{ hinweis }}

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        neueEmail: '',
        hinweis: '',
        logoUrl: null
      }
    },
    mounted () {
      this.loadLogo()
    },
    computed: {
      user () {
        if (this.$firebase.auth().currentUser) {
          return this.$firebase.auth().currentUser
        }
      },
      mail () {
        if (this.$firebase.auth().currentUser) {
          return this.$firebase.auth().currentUser.email
        }
      },
      mailStatus () {
        if (this.$firebase.auth().currentUser) {
          return this.$firebase.auth().currentUser.emailVerified
        }
      }
    },
    methods: {
      async loadLogo () {
        try {
          const url = await this.logoImage()
          console.log(url)
          this.logoUrl = url
        } catch (error) {
          console.error('Error loading logo:', error)
        }
      },
      async logoImage () {
        try {
          const storagePath = `/design/logo/${this.$vars.verbindung}`
          const url = await this.$firebase.storage().ref(storagePath).getDownloadURL()
          return url
        } catch (error) {
          console.error(error)
          throw error // Rethrow the error to be caught in the calling function
        }
      },
      updateEmail () {
        let user = this.$firebase.auth().currentUser
        user.updateEmail(this.neueEmail).then(function () {
          user.sendEmailVerification().then(function () {
            this.hinweis = 'Es wurde eine E-Mail gesendet. In dieser musst du deine Adresse bestätigen.'
            this.neueEmail = ''
          }).catch(error => {
            console.log(error)
          })
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
.container{
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// UpdateMail.vue?7f8b4b16